var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container spmManageDetail" },
    [
      _c(
        "el-form",
        {
          ref: "createParams",
          attrs: {
            model: _vm.createParams,
            "label-width": "140px",
            disabled: "",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("spm.trak"), prop: "serialNo" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.serialNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "serialNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.serialNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("spm.ssrNo"), prop: "ssrNo" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.ssrNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "ssrNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.ssrNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("spm.rfpNo"), prop: "rfpNo" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.rfpNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "rfpNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.rfpNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Category1" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.catagory1Name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "catagory1Name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.catagory1Name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Category2" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.category2Name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "category2Name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.category2Name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("spm.creator") } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.creator,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "creator",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.creator",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("spm.createDate") } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm._f("dateFormatFilter")(
                            _vm.createParams.createDate,
                            "YYYY-MM-DD"
                          ),
                          clearable: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("spm.finishDate") } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.finishDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "finishDate",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.finishDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.emplFlag != "SUP",
                      expression: "emplFlag != 'SUP'",
                    },
                  ],
                  attrs: { span: 8 },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("spm.ApprovalComments") } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.createParams.auditRemark,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.createParams,
                              "auditRemark",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "createParams.auditRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: _vm.$t("spm.day") } }, [
                    _c("span", [_vm._v(_vm._s(_vm.day) + "天")]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.createParams.isCreator &&
      _vm.createParams.status == "SCORED" &&
      _vm.createParams.shareFlag != "Y"
        ? _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.shareMark } },
                [_vm._v(_vm._s(_vm.$t("spm.pushScore")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "tableFrame" }, [
        _c(
          "div",
          {
            ref: "tableFrameHead",
            staticClass: "tableFrameHead",
            on: {
              scroll: function ($event) {
                return _vm.headHandleScroll()
              },
            },
          },
          _vm._l(_vm.bigCategoryDtos, function (item, index) {
            return _c(
              "ul",
              { key: index, style: { width: _vm.computWidth + "px" } },
              [
                index == 0
                  ? [
                      _c(
                        "li",
                        {
                          staticClass: "bigType",
                          staticStyle: { width: "40px" },
                        },
                        [_vm._v(_vm._s(index + 1) + ")")]
                      ),
                      _c(
                        "li",
                        {
                          staticClass: "bigType",
                          staticStyle: { width: "200px" },
                          attrs: { title: item.bigName },
                        },
                        [_vm._v(_vm._s(item.bigName))]
                      ),
                      _c("li", {
                        staticClass: "bigType",
                        staticStyle: { width: "500px" },
                      }),
                      _c(
                        "li",
                        {
                          staticClass: "bigType",
                          staticStyle: { width: "80px" },
                        },
                        [_vm._v(_vm._s(item.score))]
                      ),
                      _vm._l(_vm.suppliers, function (supplier, sIndex) {
                        return _c(
                          "li",
                          {
                            key: sIndex,
                            staticClass: "bigType",
                            style: { width: _vm.supplierNameWidth + "px" },
                            attrs: { title: supplier.supplierName },
                          },
                          [
                            index == 0
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(supplier.supplierName) + " "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      index == 0
                        ? _c(
                            "ul",
                            [
                              _c("li", { staticStyle: { width: "40px" } }),
                              _c("li", { staticStyle: { width: "200px" } }),
                              _c("li", { staticStyle: { width: "500px" } }),
                              _c("li", { staticStyle: { width: "80px" } }, [
                                _vm._v("目标分值"),
                              ]),
                              _vm._l(
                                _vm.suppliers,
                                function (supplier, sIndex) {
                                  return _c(
                                    "span",
                                    {
                                      key: sIndex,
                                      staticStyle: {
                                        width: "400px",
                                        "border-top": "#ccc 1px solid",
                                      },
                                    },
                                    [
                                      _vm.createParams.needSupplierSelfMark ==
                                      "Y"
                                        ? _c(
                                            "li",
                                            {
                                              style: {
                                                width:
                                                  _vm.createParams
                                                    .needSupplierSelfMark ==
                                                    "Y" &&
                                                  _vm.createParams.status !=
                                                    "SUPSUBMIT" &&
                                                  _vm.emplFlag != "SS"
                                                    ? "270px"
                                                    : "70px",
                                                fontSize: "12px",
                                                paddingRight: 0,
                                              },
                                            },
                                            [_vm._v("供应商自评")]
                                          )
                                        : _vm._e(),
                                      _vm.emplFlag == "SS" ||
                                      _vm.createParams.shareFlag == "Y"
                                        ? _c(
                                            "li",
                                            {
                                              style: {
                                                width:
                                                  _vm.emplFlag == "SS" &&
                                                  _vm.createParams.status !=
                                                    "TO_VP_APPROVE"
                                                    ? "270px"
                                                    : "70px",
                                                fontSize: "12px",
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                              },
                                            },
                                            [_vm._v("SS评分")]
                                          )
                                        : _vm._e(),
                                      _vm.isSSDirector &&
                                      _vm.createParams.ttSsrRoundId == null
                                        ? _c(
                                            "li",
                                            {
                                              staticStyle: {
                                                width: "110px",
                                                "font-size": "12px",
                                                "padding-left": "0",
                                              },
                                            },
                                            [_vm._v("SS SD复核")]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
        _c(
          "div",
          {
            ref: "tableFrameBody",
            staticClass: "tableFrameBody",
            on: {
              scroll: function ($event) {
                return _vm.bodyHandleScroll()
              },
            },
          },
          [
            _vm._l(_vm.bigCategoryDtos, function (item, index) {
              return _c(
                "ul",
                { key: index, style: { width: _vm.computWidth + "px" } },
                [
                  index != 0
                    ? _c(
                        "span",
                        [
                          _c(
                            "li",
                            {
                              staticClass: "bigType",
                              staticStyle: { width: "40px" },
                            },
                            [_vm._v(_vm._s(index + 1) + ")")]
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "bigType",
                              staticStyle: { width: "200px" },
                              attrs: { title: item.bigName },
                            },
                            [_vm._v(_vm._s(item.bigName))]
                          ),
                          _c("li", {
                            staticClass: "bigType",
                            staticStyle: { width: "500px" },
                          }),
                          _c(
                            "li",
                            {
                              staticClass: "bigType",
                              staticStyle: { width: "80px" },
                            },
                            [_vm._v(_vm._s(item.score))]
                          ),
                          _vm._l(_vm.suppliers, function (supplier, sIndex) {
                            return _c(
                              "li",
                              {
                                key: sIndex,
                                staticClass: "bigType",
                                style: { width: _vm.supplierNameWidth + "px" },
                                attrs: { title: supplier.supplierName },
                              },
                              [
                                false
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(supplier.supplierName) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  false
                    ? _c(
                        "ul",
                        [
                          _c("li", { staticStyle: { width: "40px" } }),
                          _c("li", { staticStyle: { width: "200px" } }),
                          _c("li", { staticStyle: { width: "500px" } }),
                          _c("li", { staticStyle: { width: "80px" } }, [
                            _vm._v("评分项分值"),
                          ]),
                          _vm._l(_vm.suppliers, function (supplier, sIndex) {
                            return _c(
                              "span",
                              {
                                key: sIndex,
                                staticStyle: {
                                  width: "400px",
                                  "border-top": "#ccc 1px solid",
                                },
                              },
                              [
                                _vm.createParams.needSupplierSelfMark == "Y"
                                  ? _c(
                                      "li",
                                      {
                                        style: {
                                          width:
                                            _vm.createParams
                                              .needSupplierSelfMark == "Y" &&
                                            _vm.createParams.status !=
                                              "SUPSUBMIT" &&
                                            _vm.emplFlag != "SS"
                                              ? "270px"
                                              : "70px",
                                          fontSize: "12px",
                                          paddingRight: 0,
                                        },
                                      },
                                      [_vm._v("供应商自评")]
                                    )
                                  : _vm._e(),
                                _vm.emplFlag == "SS" ||
                                _vm.createParams.shareFlag == "Y"
                                  ? _c(
                                      "li",
                                      {
                                        style: {
                                          width:
                                            _vm.emplFlag == "SS" &&
                                            _vm.createParams.status !=
                                              "TO_VP_APPROVE"
                                              ? "270px"
                                              : "70px",
                                          fontSize: "12px",
                                          paddingLeft: 0,
                                          paddingRight: 0,
                                        },
                                      },
                                      [_vm._v("SS评分")]
                                    )
                                  : _vm._e(),
                                _vm.isSSDirector
                                  ? _c(
                                      "li",
                                      {
                                        staticStyle: {
                                          width: "110px",
                                          "font-size": "12px",
                                          "padding-left": "0",
                                        },
                                      },
                                      [_vm._v("SS SD复核")]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._l(item.smallItemDtos, function (small, index1) {
                    return _c(
                      "ul",
                      { key: index1 },
                      [
                        _c("li", { staticStyle: { width: "40px" } }),
                        _c(
                          "li",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { title: small.smallName },
                          },
                          [_vm._v(_vm._s(small.smallName))]
                        ),
                        _c(
                          "li",
                          {
                            staticStyle: { width: "500px" },
                            attrs: { title: small.remark },
                          },
                          [_vm._v(_vm._s(small.remark))]
                        ),
                        _c("li", { staticStyle: { width: "80px" } }, [
                          _vm._v(_vm._s(small.smallScore)),
                        ]),
                        _vm._l(small.scoreDataDtos, function (score, sIndex) {
                          return _c(
                            "li",
                            { key: sIndex },
                            [
                              [
                                _vm.createParams.needSupplierSelfMark == "Y"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        [
                                          small.scoreDataDtosup[sIndex].remarks[
                                            small.aa
                                          ] &&
                                          (_vm.createParams.status ==
                                            "SUPSUBMIT" ||
                                            _vm.emplFlag == "SS")
                                            ? _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      small.scoreDataDtosup[
                                                        sIndex
                                                      ].remarks[small.aa],
                                                    placement: "right",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-badge",
                                                    {
                                                      staticClass: "item",
                                                      attrs: { "is-dot": "" },
                                                    },
                                                    [
                                                      _vm.createParams
                                                        .needSupplierSelfMark ==
                                                      "Y"
                                                        ? _c("el-input", {
                                                            staticStyle: {
                                                              width: "70px",
                                                              "vertical-align":
                                                                "top",
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              disabled:
                                                                _vm.emplFlag ==
                                                                "SS",
                                                            },
                                                            model: {
                                                              value:
                                                                small
                                                                  .scoreDataDtosup[
                                                                  sIndex
                                                                ].scores[
                                                                  small.aa
                                                                ],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    small
                                                                      .scoreDataDtosup[
                                                                      sIndex
                                                                    ].scores,
                                                                    small.aa,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "small.scoreDataDtosup[sIndex].scores[small.aa]",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : [
                                                _vm.createParams
                                                  .needSupplierSelfMark == "Y"
                                                  ? _c("el-input", {
                                                      staticStyle: {
                                                        width: "70px",
                                                        "vertical-align": "top",
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        disabled:
                                                          _vm.emplFlag == "SS",
                                                      },
                                                      model: {
                                                        value:
                                                          small.scoreDataDtosup[
                                                            sIndex
                                                          ].scores[small.aa],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            small
                                                              .scoreDataDtosup[
                                                              sIndex
                                                            ].scores,
                                                            small.aa,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "small.scoreDataDtosup[sIndex].scores[small.aa]",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                        ],
                                        _vm.createParams.needSupplierSelfMark ==
                                          "Y" &&
                                        _vm.createParams.status !=
                                          "SUPSUBMIT" &&
                                        _vm.emplFlag != "SS"
                                          ? _c("el-input", {
                                              staticStyle: {
                                                width: "200px",
                                                "vertical-align": "top",
                                              },
                                              attrs: {
                                                disabled: _vm.emplFlag == "SS",
                                                placeholder: "备注",
                                                type: "textarea",
                                                autosize: "",
                                                maxlength: "1000",
                                              },
                                              model: {
                                                value:
                                                  small.scoreDataDtosup[sIndex]
                                                    .remarks[small.aa],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    small.scoreDataDtosup[
                                                      sIndex
                                                    ].remarks,
                                                    small.aa,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "small.scoreDataDtosup[sIndex].remarks[small.aa]",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ],
                              [
                                [
                                  small.scoreDataDtos[sIndex].remarks[
                                    small.aa
                                  ] &&
                                  _vm.createParams.status == "TO_VP_APPROVE"
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              small.scoreDataDtos[sIndex]
                                                .remarks[small.aa],
                                            placement: "right",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-badge",
                                            {
                                              staticClass: "item",
                                              attrs: { "is-dot": "" },
                                            },
                                            [
                                              _vm.emplFlag == "SS" ||
                                              _vm.createParams.shareFlag == "Y"
                                                ? _c("el-input", {
                                                    class: {
                                                      highlightClass:
                                                        small.scoreDataDtos[
                                                          sIndex
                                                        ].Highlight[small.aa] ==
                                                          "Y" &&
                                                        _vm.SpmScmVpApprove,
                                                    },
                                                    staticStyle: {
                                                      width: "70px",
                                                      "vertical-align": "top",
                                                    },
                                                    attrs: {
                                                      type: "number",
                                                      disabled: _vm.disSS,
                                                    },
                                                    model: {
                                                      value:
                                                        small.scoreDataDtos[
                                                          sIndex
                                                        ].scores[small.aa],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          small.scoreDataDtos[
                                                            sIndex
                                                          ].scores,
                                                          small.aa,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "small.scoreDataDtos[sIndex].scores[small.aa]",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : [
                                        _vm.emplFlag == "SS" ||
                                        _vm.createParams.shareFlag == "Y"
                                          ? _c("el-input", {
                                              class: {
                                                highlightClass:
                                                  small.scoreDataDtos[sIndex]
                                                    .Highlight[small.aa] ==
                                                    "Y" && _vm.SpmScmVpApprove,
                                              },
                                              staticStyle: {
                                                width: "70px",
                                                "vertical-align": "top",
                                              },
                                              attrs: {
                                                type: "number",
                                                disabled: _vm.disSS,
                                              },
                                              model: {
                                                value:
                                                  small.scoreDataDtos[sIndex]
                                                    .scores[small.aa],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    small.scoreDataDtos[sIndex]
                                                      .scores,
                                                    small.aa,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "small.scoreDataDtos[sIndex].scores[small.aa]",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                ],
                                _vm.emplFlag == "SS" &&
                                _vm.createParams.status != "TO_VP_APPROVE"
                                  ? _c("el-input", {
                                      staticStyle: {
                                        width: "200px",
                                        "vertical-align": "top",
                                      },
                                      attrs: {
                                        placeholder: "备注",
                                        disabled: _vm.disSS,
                                        type: "textarea",
                                        autosize: "",
                                        maxlength: "1000",
                                      },
                                      model: {
                                        value:
                                          small.scoreDataDtos[sIndex].remarks[
                                            small.aa
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            small.scoreDataDtos[sIndex].remarks,
                                            small.aa,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "small.scoreDataDtos[sIndex].remarks[small.aa]",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              _vm.isSSDirector &&
                              _vm.createParams.ttSsrRoundId == null
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "110px",
                                        display: "inline-block",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "andy",
                                        staticStyle: {
                                          width: "70px",
                                          "vertical-align": "top",
                                        },
                                        style: {
                                          background:
                                            small.scoreDataDtovp[sIndex]
                                              .Highlight[small.aa] == "Y"
                                              ? "red"
                                              : "",
                                        },
                                        attrs: {
                                          type: "number",
                                          placeholder: "andy",
                                          disabled: _vm.disSSDirector,
                                        },
                                        model: {
                                          value:
                                            small.scoreDataDtovp[sIndex].scores[
                                              small.aa
                                            ],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              small.scoreDataDtovp[sIndex]
                                                .scores,
                                              small.aa,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "small.scoreDataDtovp[sIndex].scores[small.aa]",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    )
                  }),
                ],
                2
              )
            }),
            _c(
              "ul",
              { style: { width: _vm.computWidth + "px" } },
              [
                _c("li", { staticStyle: { width: "40px" } }),
                _c("li", { staticStyle: { width: "200px" } }),
                _c("li", { staticStyle: { width: "500px" } }),
                _c("li", { staticStyle: { width: "80px" } }, [
                  _vm._v("Total:"),
                ]),
                _vm._l(_vm.countScore, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      style: { width: _vm.supplierNameWidth + "px" },
                    },
                    [
                      _vm.createParams.needSupplierSelfMark == "Y"
                        ? _c("el-input", {
                            staticStyle: { width: "70px" },
                            attrs: { disabled: "" },
                            model: {
                              value: item.selfMark,
                              callback: function ($$v) {
                                _vm.$set(item, "selfMark", $$v)
                              },
                              expression: "item.selfMark",
                            },
                          })
                        : _vm._e(),
                      _vm.emplFlag == "SS" || _vm.createParams.shareFlag == "Y"
                        ? _c("el-input", {
                            staticStyle: { width: "70px" },
                            attrs: { disabled: "" },
                            model: {
                              value: item.ssMark,
                              callback: function ($$v) {
                                _vm.$set(item, "ssMark", $$v)
                              },
                              expression: "item.ssMark",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ],
          2
        ),
      ]),
      _vm.emplFlag == "SS"
        ? _c(
            "div",
            _vm._l(_vm.fileList, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { "padding-bottom": "5px" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.downloadFile(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.documentName))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "20px" },
                      attrs: { type: "primary", size: "mini" },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.deleteFile(
                            item.tmDocumentId,
                            index,
                            _vm.fileList
                          )
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.del")) + " ")]
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _c(
        "el-row",
        {
          staticStyle: { "padding-top": "15px" },
          attrs: { type: "flex", justify: "center" },
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.createParams.canSubmit,
                  expression: "createParams.canSubmit",
                },
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.SaveOrUpdateMark,
                  expression: "SaveOrUpdateMark",
                },
              ],
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save("save")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.saveDraft")) + " ")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.createParams.canSave,
                  expression: "createParams.canSave",
                },
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.SaveOrUpdateMark,
                  expression: "SaveOrUpdateMark",
                },
              ],
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save("submit")
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.createParams.status == "TO_SS_UPDATE"
                      ? _vm.$t("spm.ConfirmRelease")
                      : _vm.$t("spm.SaveOrUpdateMark")
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.createParams.canAudit,
                  expression: "createParams.canAudit",
                },
              ],
              attrs: { type: "primary" },
              on: { click: _vm.approvalFun },
            },
            [_vm._v(_vm._s(_vm.$t("spm.canAudit")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.historyBack } },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.emplFlag == "SS",
                  expression: "emplFlag == 'SS'",
                },
              ],
              attrs: { type: "primary" },
              on: { click: _vm.markDownload },
            },
            [_vm._v(_vm._s(_vm.$t("spm.DownloadExcel")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "Chart", visible: _vm.showGantt },
          on: {
            close: function ($event) {
              _vm.showGantt = false
            },
          },
        },
        [
          _c("Echart", {
            attrs: {
              scheduleList: _vm.suppliers,
              show: _vm.showGantt,
              "big-category-dtos": _vm.bigCategoryDtos,
              "score-data-dtos": _vm.scoreDataDtos,
              "score-data-dtosup": _vm.scoreDataDtosup,
              "is-sel": _vm.createParams.needSupplierSelfMark,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.approvalVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approvaForm",
              attrs: {
                model: _vm.approvaForm,
                rules: _vm.approvaRules,
                inline: "",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.auditor"),
                    prop: "auditor",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.auditor,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "auditor", $$v)
                      },
                      expression: "approvaForm.auditor",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalTime"),
                    prop: "approvalTime",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.approvalTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalTime", $$v)
                      },
                      expression: "approvaForm.approvalTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("settlementUnit.approvalRemarks"),
                    prop: "auditRemark",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      maxlength: "300",
                    },
                    model: {
                      value: _vm.approvaForm.auditRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "auditRemark", $$v)
                      },
                      expression: "approvaForm.auditRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.approvalVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("spm.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approvalConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("spm.determine")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }